/* ============================================================
   MIILKs — shared scent data (single source of truth)
   Consumed by scents-education.js (homepage lightbox) and
   product.js (the templated PDP). Exposes window.MIILK_SCENTS
   (array, in display order) and window.MIILK_BY_KEY (map).
   ============================================================ */
(function () {
  'use strict';

  var SCENTS = [
    {
      key: 'coconut', no: 'No. 01', name: 'Coconut', full: 'Coconut Miilk · 3 oz · 90 ml',
      price: '$69', priceNum: 69,
      bottle: 'bottle-coconut.png', still: 'still-coconut.png', video: 'film-coconut.mp4', mediaW: 1440, mediaH: 1440,
      tagline: 'Not the beach. The inside.',
      story: 'Forget the suntan oil and the piña colada. This is the cool, creamy flesh inside the shell — coconut milk pressed soft with caramel and green palm leaf. Tropical, but quiet about it. The one that makes people lean in and ask, wait, what is that.',
      pyramid: [
        { stage: 'Top', time: 'First minutes', notes: 'Coconut Milk · Palm Leaf · Caramel' },
        { stage: 'Heart', time: 'The middle hours', notes: 'Tiaré · Jasmine · Frangipani' },
        { stage: 'Dry-down', time: 'Hours in, on skin', notes: 'Amber · Sandalwood' }
      ],
      notesTable: [
        { note: 'Coconut Milk', pct: '24%' },
        { note: 'Palm Leaf · Caramel', pct: '18%' },
        { note: 'Tiaré · Jasmine', pct: '22%' },
        { note: 'Amber · Sandalwood', pct: '36%' }
      ],
      ingredients: 'Alcohol Denat., Parfum (Fragrance), Aqua (Water), Cocos Nucifera (Coconut) extract, Benzyl Salicylate, Linalool, Coumarin, Benzyl Benzoate, Limonene. Skin-safe, fabric-safe, never tested on animals.',
      wear: 'A clean neck and the inner wrists. It blooms in warmth — body heat unfurls the tiaré heart across the whole afternoon.',
      who: 'The effortlessly warm one. Disarming. Fills a room without ever raising its voice.',
      layer: { withKey: 'marshmallow', withName: 'Marshmallow', note: ' on top turns it pillowy and almost edible.' },
      rating: 4.9, reviewCount: 1284,
      reviews: [
        { name: 'Priya R.', loc: 'verified buyer', stars: 5, title: 'The “what is that” scent', body: 'Three people asked me on the first day. It’s creamy and warm without being sunscreen-y at all. Lasts the whole work day on me.' },
        { name: 'Dani M.', loc: 'verified buyer', stars: 5, title: 'Cozy but grown', body: 'I expected a candle. Got a real perfume. The dry-down is gorgeous — soft amber and woods. Already on my second bottle.' },
        { name: 'Tasha L.', loc: 'verified buyer', stars: 4, title: 'Subtle in the best way', body: 'A true skin scent. Not a loud coconut — it sits close. I layer it with Marshmallow and it’s unreal.' }
      ]
    },
    {
      key: 'cereal', no: 'No. 02', name: 'Cereal', full: 'Cereal Miilk · 3 oz · 90 ml',
      price: '$69', priceNum: 69,
      bottle: 'bottle-cereal.png', still: 'still-cereal.png', video: 'film-cereal.mp4', mediaW: 1080, mediaH: 1920,
      tagline: 'Saturday morning, bottled.',
      story: 'The sweet milk left at the bottom of the bowl after the cartoons ended. Lemon and marshmallow foam up top, a true cereal-milk accord at the heart, tonka and white musk underneath so it never tips into candy. The one everyone asks about — and the one you run out of first.',
      pyramid: [
        { stage: 'Top', time: 'First minutes', notes: 'Sweet Lemon · Marshmallow Foam' },
        { stage: 'Heart', time: 'The middle hours', notes: 'Cereal Milk Accord · Vanilla Orchid' },
        { stage: 'Dry-down', time: 'Hours in, on skin', notes: 'Tonka · White Musk' }
      ],
      notesTable: [
        { note: 'Sweet Lemon', pct: '14%' },
        { note: 'Marshmallow Foam', pct: '20%' },
        { note: 'Cereal Milk Accord', pct: '32%' },
        { note: 'Tonka · White Musk', pct: '34%' }
      ],
      ingredients: 'Alcohol Denat., Parfum (Fragrance), Aqua (Water), Lactose-free Milk Accord, Coumarin, Vanillin, Linalool, Benzyl Benzoate, Limonene. Skin-safe, fabric-safe, never tested on animals.',
      wear: 'One spray to the chest, one to the hair. It is a comfort-radius scent — at its best when it drifts and someone catches it.',
      who: 'The crowd favourite. The conversation-starter. The bottle that empties before the rest.',
      layer: { withKey: 'strawberry', withName: 'Strawberry', note: ' on top for a cereal-and-fruit bowl — an extra hit of brightness.' },
      rating: 4.9, reviewCount: 2071,
      reviews: [
        { name: 'Mariah K.', loc: 'verified buyer', stars: 5, title: 'Smells like my childhood', body: 'It is genuinely the bottom-of-the-bowl cereal milk. Sweet but somehow still wearable to the office. My most-complimented fragrance ever.' },
        { name: 'Jordan P.', loc: 'verified buyer', stars: 5, title: 'Ran out in a month', body: 'Warning: you will reach for this every single day. Cozy, nostalgic, addictive. Buying two next time.' },
        { name: 'Elise V.', loc: 'verified buyer', stars: 5, title: 'The hype is real', body: 'Was skeptical a “cereal” perfume could be chic. It is. The tonka base keeps it from being childish. Obsessed.' }
      ]
    },
    {
      key: 'marshmallow', no: 'No. 03', name: 'Marshmallow', full: 'Marshmallow Miilk · 3 oz · 90 ml',
      price: '$69', priceNum: 69,
      bottle: 'bottle-marshmallow.png', still: 'still-marshmallow.png', video: 'film-marshmallow.mp4', mediaW: 1080, mediaH: 1920,
      tagline: 'A really good blanket.',
      story: 'Soft, pillowy, embarrassingly good — the scent equivalent of a really good blanket. Lemon and marshmallow crème lift into fresh milk and sheer petals, then settle onto white musk, vanilla and sandalwood. A skin scent you will keep reaching for.',
      pyramid: [
        { stage: 'Top', time: 'First minutes', notes: 'Lemon · Marshmallow Crème' },
        { stage: 'Heart', time: 'The middle hours', notes: 'Fresh Milk · Sheer Petals' },
        { stage: 'Dry-down', time: 'Hours in, on skin', notes: 'White Musk · Vanilla · Sandalwood' }
      ],
      notesTable: [
        { note: 'Lemon · Marshmallow', pct: '22%' },
        { note: 'Fresh Milk', pct: '28%' },
        { note: 'Sheer Petals', pct: '18%' },
        { note: 'White Musk · Vanilla', pct: '32%' }
      ],
      ingredients: 'Alcohol Denat., Parfum (Fragrance), Aqua (Water), Milk Accord, Coumarin, Vanillin, Linalool, Hydroxycitronellal, Benzyl Benzoate. Skin-safe, fabric-safe, never tested on animals.',
      wear: 'Your everyday base layer. Wrists, neck, and a soft cloud sprayed ahead of you to walk through.',
      who: 'The quiet one you trust. Low-key, dependable, and somehow always the most comforting thing in the room.',
      layer: { withKey: 'strawberry', withName: 'Strawberry', note: ' for a soft berries-and-cream effect, or Coconut for pure comfort.' },
      rating: 4.8, reviewCount: 1639,
      reviews: [
        { name: 'Sofia A.', loc: 'verified buyer', stars: 5, title: 'My signature now', body: 'The softest skin scent. People hug me and ask what I’m wearing. It just smells like a better version of me.' },
        { name: 'Bex T.', loc: 'verified buyer', stars: 5, title: 'Layers with everything', body: 'I spray this under all my other Miilks. It rounds every edge. Endlessly comforting and never cloying.' },
        { name: 'Noor H.', loc: 'verified buyer', stars: 4, title: 'Gentle and clean', body: 'Closer to the skin than I expected — reapply midday if you want projection. But the smell is pure cashmere.' }
      ]
    },
    {
      key: 'strawberry', no: 'No. 04', name: 'Strawberry', full: 'Strawberry Miilk · 3 oz · 90 ml',
      price: '$69', priceNum: 69,
      bottle: 'bottle-strawberry.png', still: 'still-strawberry.png', video: 'film-strawberry.mp4', mediaW: 1080, mediaH: 1920,
      tagline: 'Gourmand, but make it girl.',
      story: 'Playful but polished. Sugared strawberries and frothed milk over ripe nectarine, drying down to vanilla and blonde woods so it stays grown. Sweet without ever being a cupcake — gourmand, but make it girl.',
      pyramid: [
        { stage: 'Top', time: 'First minutes', notes: 'Strawberries · Sugar Crystals' },
        { stage: 'Heart', time: 'The middle hours', notes: 'Frothed Milk · Nectarine' },
        { stage: 'Dry-down', time: 'Hours in, on skin', notes: 'Vanilla · Blonde Woods' }
      ],
      notesTable: [
        { note: 'Strawberries · Sugar', pct: '20%' },
        { note: 'Frothed Milk', pct: '26%' },
        { note: 'Nectarine', pct: '16%' },
        { note: 'Vanilla · Blonde Woods', pct: '38%' }
      ],
      ingredients: 'Alcohol Denat., Parfum (Fragrance), Aqua (Water), Fragaria (Strawberry) extract, Milk Accord, Vanillin, Linalool, Benzyl Benzoate, Limonene. Skin-safe, fabric-safe, never tested on animals.',
      wear: 'The one you wear when you already feel good. Pulse points, plus a little through the hair for lift.',
      who: 'Bright, a little flirtatious, fully in on the joke. Knows it is fun and wears it anyway.',
      layer: { withKey: 'marshmallow', withName: 'Marshmallow', note: ' to round the edges, or Cereal for a fruit-and-milk bowl.' },
      rating: 4.8, reviewCount: 1502,
      reviews: [
        { name: 'Camille D.', loc: 'verified buyer', stars: 5, title: 'Fun but not juvenile', body: 'Sugared strawberries that dry down to a creamy vanilla. It reads expensive, not like candy. My summer signature.' },
        { name: 'Reese O.', loc: 'verified buyer', stars: 5, title: 'Compliment magnet', body: 'I feel like the main character wearing this. Bright, a little flirty, and the milk note keeps it grown. Love.' },
        { name: 'Yuki S.', loc: 'verified buyer', stars: 4, title: 'Real strawberry, real milk', body: 'Not a syrupy mess like most fruit scents. The nectarine in the middle is such a nice touch. Layer with Marshmallow!' }
      ]
    }
  ];

  /* Resolve bare asset filenames through the Shopify asset_url map that the
     scent-education section injects as window.MIILK_ASSET_URLS. Falls back to
     the local ./assets/ folder when previewed outside Shopify. */
  function miilkAsset(f) {
    if (!f) return f;
    var map = window.MIILK_ASSET_URLS || {};
    return map[f] || ('assets/' + f);
  }
  SCENTS.forEach(function (s) {
    s.bottle = miilkAsset(s.bottle);
    s.still = miilkAsset(s.still);
    s.video = miilkAsset(s.video);
  });

  var byKey = {};
  SCENTS.forEach(function (s, i) { s.index = i; byKey[s.key] = s; });

  /* Merge Shopify block overrides (product, video, colors, popup content)
     set by the section into each matching scent. Blank/empty admin fields
     never overwrite good defaults. */
  var overrides = window.MIILK_PRODUCT_OVERRIDES || {};
  SCENTS.forEach(function (s) {
    var o = overrides[s.key];
    if (!o) return;

    if (o.video) s.video = o.video;
    if (o.price) { s.price = o.price; s.priceNum = o.priceNum; }
    s.variantId = o.variantId || null;
    s.productId = o.productId || null;
    s.productUrl = o.productUrl || '';

    if (o.tileColor) s.tileColor = o.tileColor;
    if (o.accentColor) s.accentColor = o.accentColor;

    if (o.story) s.story = o.story;
    if (o.wear) s.wear = o.wear;
    if (o.who) s.who = o.who;

    if (o.pyramidTop) s.pyramid[0].notes = o.pyramidTop;
    if (o.pyramidHeart) s.pyramid[1].notes = o.pyramidHeart;
    if (o.pyramidDry) s.pyramid[2].notes = o.pyramidDry;
  });

  window.MIILK_SCENTS = SCENTS;
  window.MIILK_BY_KEY = byKey;
})();